import { registerLocaleData } from '@angular/common';
import { Injectable } from '@angular/core';
import { MatDateFormats } from '@angular/material/core';
import localePt from '@angular/common/locales/pt';

import dayjs from 'dayjs';

registerLocaleData(localePt, 'pt-PT');

export const MY_DATE_FORMAT: MatDateFormats = {
  parse: {
    dateInput: 'DD-MM-YYYY',
  },
  display: {
    dateInput: 'DD-MM-YYYY',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'DD-MM-YYYY',
    monthYearA11yLabel: 'YYYY',
  },
};

export const CUSTOM_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: 'DD-MM-YYYY HH:mm',
  },
  display: {
    dateInput: 'DD-MM-YYYY HH:mm',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'DD-MM-YYYY',
    monthYearA11yLabel: 'YYYY',
  },
};

@Injectable({
  providedIn: 'root',
})
export class DatetimeService {
  constructor() {}

  // Função para validar se a data expirou
  isDateExpired(date: Date | null | undefined): boolean {
    if (!date) {
      return false;
    }
    const currentDate = new Date();
    return date < currentDate;
  }

  formatTime(date: Date): string | null {
    if (!date) {
      return null;
    }
    return dayjs(date).format('HH:mm');
  }

  formatDate(date: any): string {
    if (!date) return '';
    return dayjs(date).format('DD-MM-YYYY');
  }

  formatDateTime(date: any): string {
    if (!date) return '';
    return dayjs(date).format('DD-MM-YYYY HH:mm');
  }

  formatDateWithMask(date: any, mask: string, includeTime: boolean = false): string {
    if (!date) return '';
    // Mapear máscaras legadas para dayjs se necessário
    let dayjsMask = mask.replace('dd', 'DD').replace('yyyy', 'YYYY');
    if (includeTime && !dayjsMask.includes('HH')) {
      dayjsMask += ' HH:mm';
    }
    return dayjs(date).format(dayjsMask);
  }

  getMonthName(month: number): string {
    const monthNames = [
      'Janeiro',
      'Fevereiro',
      'Março',
      'Abril',
      'Maio',
      'Junho',
      'Julho',
      'Agosto',
      'Setembro',
      'Outubro',
      'Novembro',
      'Dezembro',
    ];
    return monthNames[month];
  }
}
